{
  "version": 1,
  "asset_id": "f4573b0f-2a7d-4126-b968-efbadef2519e",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/f4573b0f-2a7d-4126-b968-efbadef2519e/og-tax-debt-relief.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/f4573b0f-2a7d-4126-b968-efbadef2519e/og-tax-debt-relief.jpg",
  "original_filename": "og-tax-debt-relief.jpg",
  "size": 182456,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T16:20:18Z"
}
